import { render, staticRenderFns } from "./WebConfig.vue?vue&type=template&id=c73fa2f4&scoped=true&"
import script from "./WebConfig.vue?vue&type=script&lang=js&"
export * from "./WebConfig.vue?vue&type=script&lang=js&"
import style0 from "./WebConfig.vue?vue&type=style&index=0&id=c73fa2f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73fa2f4",
  null
  
)

export default component.exports